import CarrierViewComponent from '@app/components/carriers/carrier-view.component';
import { Card } from '@material-ui/core';
import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';

class SideBarCarrierViewComponent extends PureComponent<any> {
	public render() {
		return (
			<Card classes={{ root: 'pl-2 pr-2 pt-2' }}>
				<CarrierViewComponent fetchAll={true} />
			</Card>
		);
	}
}

export default withRouter(SideBarCarrierViewComponent);



// WEBPACK FOOTER //
// ./src/components/carriers/sidebar-carrier-view.component.tsx